import * as R from "remeda";
import { MissionEventRecord, MissionRecord } from "../types";
import { displayTime, eventMarked } from "./functions";
import { downloadCSV, useListContext, useRecordContext } from "react-admin";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import jsonExport from "jsonexport/dist";

const formatDateTime = (time: string) => new Date(time).toLocaleString();
const formatDate = (time: string) => new Date(time).toLocaleDateString();

enum Header {
	MissionEvent = "Mission Event",
	Time = "Time",
	Eta = "ETA",
	Comments = "Comments",
}

const exportCSV = (
	mission: MissionRecord,
	missionEvents: MissionEventRecord[]
) => {
	const missionStart = {
		[Header.MissionEvent]: "Mission start",
		[Header.Time]: formatDateTime(mission.start_time),
		[Header.Eta]: null,
		[Header.Comments]: null,
	};

	const intermediateEvents = R.pipe(
		missionEvents,
		R.filter(eventMarked),
		R.sortBy(displayTime),
		R.map((event) => ({
			[Header.MissionEvent]: event.name,
			[Header.Time]: event.time && formatDateTime(event.time),
			[Header.Eta]: event.eta && formatDateTime(event.eta),
			[Header.Comments]: event.comments,
		}))
	);

	const missionEnd = {
		[Header.MissionEvent]: "Mission end",
		[Header.Time]: formatDateTime(mission.end_time),
		[Header.Eta]: null,
		[Header.Comments]: null,
	};

	const missionEventsForExport = [
		missionStart,
		...intermediateEvents,
		missionEnd,
	];

	jsonExport(
		missionEventsForExport,
		{
			headers: Object.values(Header),
		},
		(err, csv) => {
			const missionDate = formatDate(mission.start_time);
			downloadCSV(csv, `Mission summary - ${mission.unos_id} - ${missionDate}`);
		}
	);
};

export const MissionSummaryExportButton = () => {
	const mission = useRecordContext<MissionRecord>();
	const { data: missionEvents = [] } = useListContext<MissionEventRecord>();

	return (
		<Button
			variant="text"
			onClick={() => exportCSV(mission, missionEvents)}
			startIcon={<DownloadIcon />}
		>
			Export
		</Button>
	);
};
